module.exports = __webpack_public_path__ + "images/link_2.jpg?09e3cfb3f0790030e6023cf94df72802";


//////////////////
// WEBPACK FOOTER
// ./client/app/images/link_2.jpg
// module id = 533
// module chunks = 1